import React, { Component } from 'react';
import Player from 'react-player';
import { observer, inject } from 'mobx-react';

import {
  Button
} from 'reactstrap';

@inject('appState')
@observer
class HomePlayer extends Component {
  render() {
    const {
      isMobile,
      width,
      modalIsOpen
    } = this.props.appState;

    return (
      <div
        style={{
          background: 'black',
          overflow: 'hidden',
          position: 'relative',
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
          height: 600
        }}
      >
        <div
          style={{
            height: 600,
            width: width,
            backgroundImage: 'linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(/assets/photos/JB_Monitor_002_Blurry.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center 25%'
          }}
          className="cover"
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            paddingTop: '100px',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            color: 'white',
            zIndex: 99
          }}
        >
          <h2 className="h1 text-uppercase" style={{ textAlign: 'center' }}>
          JOE BANDELLI<br/>WRITER, DIRECTOR, PRODUCER
          </h2>
          <div className="text-center">
            <Button
              color="secondary"
              className="m-2"
              size="lg"
              outline
              onClick={() =>
                this.props.appState.openAndPlay({
                  title: 'Film Reel',
                  url: 'https://vimeo.com/220653508'
                })}
            >
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <i className="fa fa-film pr-2" />
                {' '}Reel
              </span>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePlayer;



// WEBPACK FOOTER //
// ./src/HomePlayer.js